import { css } from '@emotion/react'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'
import { AcompanhamentoPreNatalVacinacao } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'

import { formatParenteses, formatSemanas } from '../formatter-acompanhamentoPreNatal'
import { removeVacinaPrefix } from '../util-acompanhamentoPreNatal'

interface ImunobiologicoSectionProps {
  isAprazada?: boolean
  showBorder?: boolean
  isCovid?: boolean
  registroVacinacao: AcompanhamentoPreNatalVacinacao
}

export function ImunobiologicoSection(props: Readonly<ImunobiologicoSectionProps>) {
  const { registroVacinacao, isCovid = false, showBorder = true, isAprazada = false } = props

  const { nomeImuno, dataRegistro, siglaDoseImuno } = registroVacinacao.vacina

  const theme = useTheme()
  const styles = createStyles(theme, showBorder)

  return (
    <VFlow vSpacing={0} style={styles.verticalDivider}>
      <Text fontWeight='bold'>
        {isCovid ? removeVacinaPrefix(nomeImuno) : nomeImuno} {formatParenteses(siglaDoseImuno)}
      </Text>
      <Text> {dataRegistro ? formatDate(dataRegistro) : 'Nenhum registro'} </Text>
      {!isAprazada && (
        <Text>
          <b>IG:</b> {formatSemanas(registroVacinacao.idadeGestacionalEmSemanasAplicacao)}
        </Text>
      )}
    </VFlow>
  )
}

const createStyles = (theme: Theme, showBorder: boolean) => ({
  verticalDivider: css`
    padding-right: 0.5rem;
    border-right: ${showBorder ? 1 : 0}px solid ${theme.pallete.divider};

    &:last-child {
      border-right: 0;
    }
  `,
})
